import { Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from '../../shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';

@Component({
    selector: 'eliminar-agenda-masiva',
    templateUrl: './eliminar-agenda-masiva.component.html',
    //  styleUrls: ['./eliminar-agenda-masiva.component.scss']
})
export class EliminarAgendaMasivaComponent implements OnInit {

    public numeroDocumento: string;
    public tipoDocumento: string;
    public fechaInicio;
    public fechaFin;
    public fechaInicioAgendada: string;
    public fechaFinAgendada: string;
    public listadoTipoDocumento = [];
    public cargando: boolean;
    public modalOptions: ConfirmationModalOptions;
    public dateEmpty:Date;
    public placeholderDate: string;


    constructor(
        private router: Router,
        private urlService: UrlService,
        private global: GlobalService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService,
    ) {

    }

    ngOnInit() {
        this.cargando = true;
        this.modalOptions =
            new ConfirmationModalOptions('Confirmación', "Está seguro de eliminar todas las agendas en el rango de fechas seleccionado",
                'SI', 'NO', 'far fa-calendar', false, false, 'Eliminar agenda', null, 'btn-secondary');
        this.tipoDocumento = null;
        this.modalOptions.disabled=true;
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.spinner.show();
        this.getTipoIdentificacion();
        
    }


    /**
     * metodo para regresar a consulat de visitas
     * @author fromero
     */
    regresarListaAgendas() {
        this.router.navigate(['main/']);
    }

    /**
     * obtiene el dominio tipo identificacion
     * jvillalobos
     */
    public getTipoIdentificacion() {
        const serviceProvider = 'getTipoIdentificacion';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                this.listadoTipoDocumento = data;
                this.spinner.hide();
                this.cargando = false;
            }, err => {
                this.cathException('Error Consultando el Dominio');
            }
        );
    }


    /**
     *
     * @param error
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    /**
     * fromero
     * obtiene la fecha seleccionada en el datepicker
     * @param event
     */
    public handlerFechaInicio(event) {
        const d = event.fecha;
        this.fechaInicioAgendada = d.year + '-' + d.month + '-' + d.day;
        this.validarCamposIncompletos();
    }

    handlerFechaFinal(event) {
        const d = event.fecha;
        this.fechaFinAgendada = d.year + '-' + d.month + '-' + d.day;
        this.validarCamposIncompletos();
    }

    getConfirmationModalResponse(event) {
        if (event[0] === true) {
            this.validarFiltros();
        }
    }

    validarFiltros() {
        if (!this.utilService.validarCamposObligatorios(this.tipoDocumento) ||
            !this.utilService.validarCamposObligatorios(this.fechaInicioAgendada) ||
            !this.utilService.validarCamposObligatorios(this.fechaFinAgendada) ||
            !this.utilService.validarCamposObligatorios(this.numeroDocumento)) {

            this.alertService.generateAlertError('Por favor ingresar los campos completos'
                , 'Error');

        } else {
            console.log("ok");
            this.eliminarAgendaMultiple();
        }
    }

    validarCamposIncompletos(){
        
        if (!this.utilService.validarCamposObligatorios(this.tipoDocumento) ||
        !this.utilService.validarCamposObligatorios(this.fechaInicioAgendada) ||
        !this.utilService.validarCamposObligatorios(this.fechaFinAgendada) ||
        !this.utilService.validarCamposObligatorios(this.numeroDocumento)) {

            this.modalOptions.disabled=true;

        } else {
            this.modalOptions.disabled=false;
        }
    }


    private eliminarAgendaMultiple() {
        this.spinner.show();
        const serviceProvider = 'eliminarAgendaMasiva';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.tipoDocumento]);
        queryParams.push(['numeroDocumento', this.numeroDocumento]);
        queryParams.push(['fechaInicio', this.fechaInicioAgendada]);
        queryParams.push(['fechaFin', this.fechaFinAgendada]);

        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        const subscribe = this.global.postGenerico(url).subscribe(
            data => {
                this.spinner.hide();
                this.alertService.generateAlertSuccess('Se eliminaron las agendas correctamente', '');
            }, err => {
                this.cathException(err.error.message);
            }
        );

    }

}
